<project-dashboard-header
  [project]="project()"
  (toolDragStarted)="onToolDragStarted($event)"
  (toolDragEnded)="onToolDragEnded()"
  (stageChanged)="onStageChanged($event)"
  (projectUpdated)="onProjectUpdated($event)"
/>

<project-dashboard-stepper
  [currentStage]="project()?.stage || null"
  [projectId]="project()?.id || null"
  [activeStep]="activeStep()"
  (stepSelected)="onStepSelected($event)"
/>

<div
  class="dashboard-container"
  [ngClass]="{
    'dashboard-container--configurator': isConfigPage(),
    'dashboard-container--configurator-v2': isConfigV2Page()
  }"
>
  <router-outlet />
</div>

<!-- The configurator v2 has its own fixed footer and summary button where the dock would be. -->
@if (!isConfigV2Page()) {
  <project-dashboard-dock [draggedToolFromHeader]="draggedToolFromHeader()" [currentRoute]="currentRoute()" />
}
